<div class="token-page mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 pt-12 pb-20">

  <!-- Header -->
  <div class="mb-10">
    <div class="flex items-start justify-between">
      <div>
        <div class="flex items-center gap-3 mb-3">
          <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
            </svg>
          </div>
          <h1 class="text-2xl font-extrabold tracking-tight" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">API Tokens</h1>
        </div>
        <p class="text-sm max-w-lg leading-relaxed" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">
          Secret keys for programmatic access. Never share tokens or expose them in client-side code.
        </p>
      </div>
      <button (click)="openCreateModal()"
        class="btn-create inline-flex items-center gap-2.5 px-5 py-2.5 text-[13px] font-semibold text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 tracking-wide uppercase"
        [ngClass]="isDarkMode() ? 'bg-emerald-600 shadow-md shadow-emerald-900/30 hover:bg-emerald-500 focus:ring-emerald-500 focus:ring-offset-gray-900' : 'bg-gray-900 shadow-md shadow-gray-900/10 hover:bg-gray-800 focus:ring-gray-900'">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
        </svg>
        New Token
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex flex-col items-center justify-center py-24">
    <div class="relative">
      <div class="w-10 h-10 rounded-full border-2" [ngClass]="isDarkMode() ? 'border-gray-700' : 'border-gray-200'"></div>
      <div class="absolute inset-0 w-10 h-10 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin"></div>
    </div>
    <p class="mt-4 text-xs font-medium tracking-widest uppercase" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">Loading tokens</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && tokens.length === 0" class="relative overflow-hidden rounded-2xl border border-dashed py-20 px-8 text-center"
    [ngClass]="isDarkMode() ? 'border-gray-700 bg-gradient-to-b from-gray-800 to-gray-800/60' : 'border-gray-200 bg-gradient-to-b from-white to-gray-50/80'">
    <div class="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,0.04),transparent_70%)]"></div>
    <div class="relative">
      <div class="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center mb-5" [ngClass]="isDarkMode() ? 'bg-gray-700' : 'bg-gray-100'">
        <svg class="w-7 h-7" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
        </svg>
      </div>
      <h3 class="text-lg font-bold mb-1" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">No tokens yet</h3>
      <p class="text-sm mb-7 max-w-xs mx-auto" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">Create your first API token to start integrating with external services.</p>
      <button (click)="openCreateModal()"
        class="btn-create inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-xl shadow-md transition-all duration-200"
        [ngClass]="isDarkMode() ? 'bg-emerald-600 shadow-emerald-900/30 hover:bg-emerald-500' : 'bg-gray-900 hover:bg-gray-800'">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path>
        </svg>
        Create your first token
      </button>
    </div>
  </div>

  <!-- Token List -->
  <div *ngIf="!loading && tokens.length > 0" class="space-y-3">
    <div *ngFor="let token of tokens; let i = index"
      class="token-card group relative rounded-xl border transition-all duration-200 hover:shadow-lg"
      [ngClass]="isDarkMode() ? 'border-gray-700/80 bg-gray-800 hover:border-gray-600 hover:shadow-black/20' : 'border-gray-200/80 bg-white hover:border-gray-300 hover:shadow-gray-100/80'">
      
      <div class="px-5 py-4">
        <div class="flex items-center justify-between mb-3">
          <!-- Token name + status -->
          <div class="flex items-center gap-3 min-w-0">
            <div class="status-dot flex-shrink-0"></div>
            <h3 class="text-sm font-bold truncate" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">{{ token.name }}</h3>
          </div>
          <!-- Actions -->
          <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <button (click)="copy(token.token)"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-150"
              [ngClass]="{
                'text-white bg-emerald-500': copyText === 'Copied!',
                'text-gray-400 bg-gray-700 hover:bg-gray-600 hover:text-gray-200': copyText !== 'Copied!' && isDarkMode(),
                'text-gray-500 bg-gray-100 hover:bg-gray-200 hover:text-gray-700': copyText !== 'Copied!' && !isDarkMode()
              }">
              <svg *ngIf="copyText !== 'Copied!'" class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9.75a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
              </svg>
              <svg *ngIf="copyText === 'Copied!'" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              {{ copyText }}
            </button>
            <button (click)="openDeleteConfirm(token)" 
              class="delete-btn p-1.5 rounded-lg transition-colors duration-150"
              [ngClass]="isDarkMode() ? 'text-gray-500 hover:text-red-400 hover:bg-red-950/40' : 'text-gray-400 hover:text-red-500 hover:bg-red-50'"
              title="Revoke token">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Token value -->
        <div class="flex items-center gap-3">
          <code class="token-mono px-3 py-1.5 rounded-lg flex-1 truncate border"
            [ngClass]="isDarkMode() ? 'text-gray-500 bg-gray-900/40 border-gray-700' : 'text-gray-400 bg-gray-50 border-gray-100'">{{ maskToken(token.token) }}</code>
          <div class="flex-shrink-0 text-right">
            <span class="text-[10px] font-semibold uppercase tracking-widest" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">Expires</span>
            <p class="text-xs font-medium mt-0.5" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-600'">{{ token.expires_in }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-between pt-3 px-1">
      <p class="text-[11px] font-medium tracking-wide" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">
        {{ tokens.length }} active token{{ tokens.length !== 1 ? 's' : '' }}
      </p>
      <div class="flex items-center gap-1.5">
        <div class="status-dot" style="width:5px;height:5px"></div>
        <span class="text-[10px] font-medium" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">All tokens active</span>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════ -->
  <!-- CONECTAR POR MCP                            -->
  <!-- ═══════════════════════════════════════════ -->
  <div *ngIf="!loading" class="mcp-section mt-10 rounded-2xl border overflow-hidden" [ngClass]="isDarkMode() ? 'border-gray-700/80 bg-gray-800' : 'border-gray-200/80 bg-white'">
    <div class="px-6 pt-6 pb-5 border-b" [ngClass]="isDarkMode() ? 'border-gray-700' : 'border-gray-100'">
      <div class="flex items-center gap-3 mb-2">
        <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-500/20 flex-shrink-0">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z" />
          </svg>
        </div>
        <div>
          <h2 class="text-base font-bold" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">Conectar por MCP</h2>
          <p class="text-xs mt-0.5" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">Da acceso a Claude, Cursor, ChatGPT o cualquier cliente MCP a tus llamadas, WhatsApp, evaluaciones y analíticas — usando el token de arriba.</p>
        </div>
      </div>
    </div>

    <div class="p-6 space-y-5">
      <!-- Server URL -->
      <div>
        <label class="block text-xs font-semibold uppercase tracking-wider mb-2" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'">URL del servidor MCP</label>
        <div class="flex items-center gap-3">
          <code class="token-mono px-3 py-2.5 rounded-lg flex-1 truncate border"
            [ngClass]="isDarkMode() ? 'text-gray-300 bg-gray-900/40 border-gray-700' : 'text-gray-700 bg-gray-50 border-gray-100'">{{ mcpUrl }}</code>
          <button (click)="copyMcpUrl()"
            class="flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-2.5 text-xs font-medium rounded-lg transition-all duration-150"
            [ngClass]="{
              'text-white bg-emerald-500': mcpUrlCopyText === 'Copied!',
              'text-gray-400 bg-gray-700 hover:bg-gray-600 hover:text-gray-200': mcpUrlCopyText !== 'Copied!' && isDarkMode(),
              'text-gray-500 bg-gray-100 hover:bg-gray-200 hover:text-gray-700': mcpUrlCopyText !== 'Copied!' && !isDarkMode()
            }">
            <svg *ngIf="mcpUrlCopyText !== 'Copied!'" class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9.75a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
            </svg>
            <svg *ngIf="mcpUrlCopyText === 'Copied!'" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
            {{ mcpUrlCopyText }}
          </button>
        </div>
      </div>

      <!-- Client tabs -->
      <div>
        <nav class="flex gap-1 border-b" [ngClass]="isDarkMode() ? 'border-gray-700' : 'border-gray-100'">
          <button type="button" (click)="setMcpTab('client')"
            class="px-3.5 py-2 text-xs font-semibold border-b-2 transition-colors duration-150"
            [ngClass]="activeMcpTab === 'client' ? (isDarkMode() ? 'border-emerald-500 text-gray-100' : 'border-emerald-500 text-gray-900') : (isDarkMode() ? 'border-transparent text-gray-500 hover:text-gray-300' : 'border-transparent text-gray-400 hover:text-gray-600')">
            Cursor / Claude / Windsurf
          </button>
          <button type="button" (click)="setMcpTab('chatgpt')"
            class="px-3.5 py-2 text-xs font-semibold border-b-2 transition-colors duration-150"
            [ngClass]="activeMcpTab === 'chatgpt' ? (isDarkMode() ? 'border-emerald-500 text-gray-100' : 'border-emerald-500 text-gray-900') : (isDarkMode() ? 'border-transparent text-gray-500 hover:text-gray-300' : 'border-transparent text-gray-400 hover:text-gray-600')">
            ChatGPT
          </button>
          <button type="button" (click)="setMcpTab('raw')"
            class="px-3.5 py-2 text-xs font-semibold border-b-2 transition-colors duration-150"
            [ngClass]="activeMcpTab === 'raw' ? (isDarkMode() ? 'border-emerald-500 text-gray-100' : 'border-emerald-500 text-gray-900') : (isDarkMode() ? 'border-transparent text-gray-500 hover:text-gray-300' : 'border-transparent text-gray-400 hover:text-gray-600')">
            Otro cliente
          </button>
        </nav>

        <!-- Cursor / Claude / Windsurf: JSON config -->
        <div *ngIf="activeMcpTab === 'client'" class="pt-4 space-y-3">
          <p class="text-xs leading-relaxed" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">
            Añade esto a <code class="token-mono px-1.5 py-0.5 rounded" [ngClass]="isDarkMode() ? 'bg-gray-700' : 'bg-gray-100'">.cursor/mcp.json</code> (Cursor),
            <code class="token-mono px-1.5 py-0.5 rounded" [ngClass]="isDarkMode() ? 'bg-gray-700' : 'bg-gray-100'">claude_desktop_config.json</code> (Claude Desktop) o la config MCP de tu cliente.
            Sustituye <code class="token-mono px-1.5 py-0.5 rounded" [ngClass]="isDarkMode() ? 'bg-gray-700' : 'bg-gray-100'">YOUR_API_TOKEN</code> por un token de arriba.
          </p>
          <div class="relative rounded-xl border" [ngClass]="isDarkMode() ? 'border-gray-700 bg-gray-900/40' : 'border-gray-200 bg-gray-50/50'">
            <button (click)="copyMcpSnippet()"
              class="absolute top-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-lg transition-all duration-200 shadow-sm z-10"
              [ngClass]="{
                'text-white bg-emerald-500 shadow-emerald-500/20': mcpCopyText === 'Copied!',
                'text-gray-300 bg-gray-800 border border-gray-600 hover:bg-gray-700 hover:border-gray-500': mcpCopyText !== 'Copied!' && isDarkMode(),
                'text-gray-600 bg-white border border-gray-200 hover:bg-gray-50 hover:border-gray-300': mcpCopyText !== 'Copied!' && !isDarkMode()
              }">
              <svg *ngIf="mcpCopyText !== 'Copied!'" class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9.75a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
              </svg>
              <svg *ngIf="mcpCopyText === 'Copied!'" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              {{ mcpCopyText }}
            </button>
            <pre class="token-mono p-4 pr-20 overflow-x-auto m-0" style="font-size:11px; line-height:1.7;" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'">{{ mcpClientConfigSnippet }}</pre>
          </div>
        </div>

        <!-- ChatGPT: manual connector setup -->
        <div *ngIf="activeMcpTab === 'chatgpt'" class="pt-4">
          <ol class="list-decimal pl-5 space-y-2 text-xs leading-relaxed" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-600'">
            <li>En ChatGPT ve a <strong [ngClass]="isDarkMode() ? 'text-gray-200' : 'text-gray-800'">Settings → Connectors → Add connector</strong> (o "Custom connector" en Deep Research / GPTs).</li>
            <li>Como <strong [ngClass]="isDarkMode() ? 'text-gray-200' : 'text-gray-800'">URL</strong> pega: <code class="token-mono px-1.5 py-0.5 rounded break-all" [ngClass]="isDarkMode() ? 'bg-gray-700' : 'bg-gray-100'">{{ mcpUrl }}</code></li>
            <li>Como autenticación elige <strong [ngClass]="isDarkMode() ? 'text-gray-200' : 'text-gray-800'">Bearer token</strong> y pega un token de la lista de arriba.</li>
            <li>Guarda y prueba pidiéndole a ChatGPT que liste tus agentes o busque una conversación reciente.</li>
          </ol>
        </div>

        <!-- Raw: any other MCP client -->
        <div *ngIf="activeMcpTab === 'raw'" class="pt-4 space-y-3">
          <p class="text-xs leading-relaxed" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">Cualquier cliente MCP compatible con Streamable HTTP y cabeceras personalizadas puede conectarse con estos dos datos:</p>
          <div class="space-y-2">
            <div class="flex items-center gap-3">
              <span class="text-[10px] font-semibold uppercase tracking-widest w-16 flex-shrink-0" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">URL</span>
              <code class="token-mono px-3 py-2 rounded-lg flex-1 truncate border" [ngClass]="isDarkMode() ? 'text-gray-300 bg-gray-900/40 border-gray-700' : 'text-gray-700 bg-gray-50 border-gray-100'">{{ mcpUrl }}</code>
            </div>
            <div class="flex items-center gap-3">
              <span class="text-[10px] font-semibold uppercase tracking-widest w-16 flex-shrink-0" [ngClass]="isDarkMode() ? 'text-gray-500' : 'text-gray-400'">Header</span>
              <code class="token-mono px-3 py-2 rounded-lg flex-1 truncate border" [ngClass]="isDarkMode() ? 'text-gray-300 bg-gray-900/40 border-gray-700' : 'text-gray-700 bg-gray-50 border-gray-100'">Authorization: Bearer {{ mcpTokenPlaceholder }}</code>
            </div>
          </div>
        </div>
      </div>

      <!-- What you get -->
      <div class="flex gap-2.5 rounded-xl p-3.5 border" [ngClass]="isDarkMode() ? 'bg-indigo-950/30 border-indigo-900/50' : 'bg-indigo-50/60 border-indigo-100'">
        <svg class="w-4 h-4 mt-0.5 flex-shrink-0" [ngClass]="isDarkMode() ? 'text-indigo-400' : 'text-indigo-500'" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
        </svg>
        <p class="text-xs leading-relaxed" [ngClass]="isDarkMode() ? 'text-indigo-300' : 'text-indigo-800'">
          Cada token está aislado a tu cuenta: el modelo solo puede ver agentes, conversaciones, contactos y analíticas de tus propios agentes — nunca de otros clientes de Meetzy.
        </p>
      </div>
    </div>
  </div>
</div>


<!-- ═══════════════════════════════════════════ -->
<!-- CREATE TOKEN MODAL                         -->
<!-- ═══════════════════════════════════════════ -->
<div *ngIf="showCreateModal" class="fixed inset-0 z-50 overflow-y-auto" aria-modal="true">
  <div class="flex min-h-full items-center justify-center p-4">
    <div class="modal-overlay fixed inset-0 bg-black/40 backdrop-blur-sm" (click)="closeCreateModal()"></div>
    
    <div class="modal-panel relative w-full max-w-md rounded-2xl shadow-2xl shadow-black/10 ring-1 overflow-hidden"
      [ngClass]="isDarkMode() ? 'bg-gray-800 ring-white/10' : 'bg-white ring-black/5'"
      (click)="$event.stopPropagation()">
      
      <!-- Success State -->
      <div *ngIf="justCreatedToken" class="p-6">
        <div class="flex items-center gap-3 mb-5">
          <div class="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/30">
            <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div>
            <h3 class="text-base font-bold" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">Token created</h3>
            <p class="text-xs mt-0.5" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">{{ justCreatedToken.name }}</p>
          </div>
        </div>

        <!-- Warning -->
        <div class="flex gap-2.5 rounded-xl p-3.5 mb-4 border" [ngClass]="isDarkMode() ? 'bg-amber-950/30 border-amber-900/50' : 'bg-amber-50 border-amber-200/70'">
          <svg class="w-4 h-4 mt-0.5 flex-shrink-0" [ngClass]="isDarkMode() ? 'text-amber-400' : 'text-amber-500'" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
          </svg>
          <p class="text-xs leading-relaxed" [ngClass]="isDarkMode() ? 'text-amber-300' : 'text-amber-800'">Copy this token now. For security, the full value <strong>won't be shown again</strong>.</p>
        </div>

        <!-- Token Display -->
        <div class="token-secret-box relative rounded-xl border p-4 mb-5" [ngClass]="isDarkMode() ? 'border-gray-700' : 'border-gray-200'">
          <code class="token-mono block pr-16 leading-relaxed" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'" style="font-size:11px">{{ justCreatedToken.token }}</code>
          <button (click)="copyJustCreated()" 
            class="absolute top-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-lg transition-all duration-200 shadow-sm"
            [ngClass]="{
              'text-white bg-emerald-500 shadow-emerald-500/20': justCreatedCopyText === 'Copied!',
              'text-gray-300 bg-gray-800 border border-gray-600 hover:bg-gray-700 hover:border-gray-500': justCreatedCopyText !== 'Copied!' && isDarkMode(),
              'text-gray-600 bg-white border border-gray-200 hover:bg-gray-50 hover:border-gray-300': justCreatedCopyText !== 'Copied!' && !isDarkMode()
            }">
            <svg *ngIf="justCreatedCopyText !== 'Copied!'" class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9.75a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
            </svg>
            <svg *ngIf="justCreatedCopyText === 'Copied!'" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
            {{ justCreatedCopyText }}
          </button>
        </div>

        <div class="flex justify-end">
          <button (click)="closeCreateModal()" 
            class="px-5 py-2 text-sm font-semibold rounded-xl transition-colors duration-150"
            [ngClass]="isDarkMode() ? 'text-gray-200 bg-gray-700 hover:bg-gray-600' : 'text-gray-700 bg-gray-100 hover:bg-gray-200'">
            Done
          </button>
        </div>
      </div>

      <!-- Create Form -->
      <div *ngIf="!justCreatedToken">
        <!-- Modal Header -->
        <div class="px-6 pt-6 pb-4 border-b" [ngClass]="isDarkMode() ? 'border-gray-700' : 'border-gray-100'">
          <h3 class="text-base font-bold" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">Create API Token</h3>
          <p class="text-xs mt-1" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">Generate a new secret key for API access.</p>
        </div>

        <div class="p-6 space-y-5">
          <!-- Token Name -->
          <div>
            <label for="token-name" class="block text-xs font-semibold uppercase tracking-wider mb-2" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'">Name</label>
            <input 
              id="token-name"
              type="text" 
              [(ngModel)]="newTokenName"
              placeholder="e.g. Production, Staging, CRM"
              class="w-full px-4 py-3 text-sm border rounded-xl transition-all duration-200 focus:ring-2"
              [ngClass]="createError
                ? (isDarkMode() ? 'border-red-800 bg-red-950/20 text-gray-100 focus:ring-red-500/20 focus:border-red-500' : 'border-red-300 bg-red-50/30 focus:ring-red-500/20 focus:border-red-500')
                : (isDarkMode() ? 'border-gray-600 bg-gray-900/40 text-gray-100 placeholder-gray-500 focus:bg-gray-900 focus:ring-emerald-500/20 focus:border-emerald-500' : 'border-gray-200 bg-gray-50/50 placeholder-gray-400 focus:bg-white focus:ring-emerald-500/20 focus:border-emerald-500')">
          </div>

          <!-- Expiration -->
          <div>
            <label class="block text-xs font-semibold uppercase tracking-wider mb-2" [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'">Expiration</label>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let option of expirationOptions"
                (click)="selectedExpiration = option.days"
                type="button"
                class="expiration-chip px-3.5 py-2 text-xs font-semibold rounded-xl border-2 transition-all duration-200"
                [ngClass]="{
                  'selected border-emerald-500': selectedExpiration === option.days,
                  'bg-emerald-950/40 text-emerald-400': selectedExpiration === option.days && isDarkMode(),
                  'bg-emerald-50 text-emerald-700': selectedExpiration === option.days && !isDarkMode(),
                  'border-gray-600 bg-gray-800 text-gray-400 hover:border-gray-500 hover:text-gray-300': selectedExpiration !== option.days && isDarkMode(),
                  'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:text-gray-700': selectedExpiration !== option.days && !isDarkMode()
                }">
                {{ option.label }}
              </button>
            </div>
          </div>

          <!-- Error -->
          <div *ngIf="createError" class="flex items-center gap-2 p-3 rounded-xl border" [ngClass]="isDarkMode() ? 'bg-red-950/30 border-red-900/50' : 'bg-red-50 border-red-100'">
            <svg class="w-4 h-4 flex-shrink-0" [ngClass]="isDarkMode() ? 'text-red-400' : 'text-red-400'" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
            </svg>
            <p class="text-xs font-medium" [ngClass]="isDarkMode() ? 'text-red-400' : 'text-red-600'">{{ createError }}</p>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="px-6 py-4 border-t flex items-center justify-end gap-3" [ngClass]="isDarkMode() ? 'bg-gray-900/30 border-gray-700' : 'bg-gray-50/50 border-gray-100'">
          <button (click)="closeCreateModal()" 
            class="px-4 py-2 text-sm font-medium transition-colors duration-150"
            [ngClass]="isDarkMode() ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-800'">
            Cancel
          </button>
          <button (click)="createToken()" 
            [disabled]="creatingToken"
            class="btn-create inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-xl shadow-md disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
            [ngClass]="isDarkMode() ? 'bg-emerald-600 shadow-emerald-900/30 hover:bg-emerald-500' : 'bg-gray-900 shadow-gray-900/10 hover:bg-gray-800'">
            <svg *ngIf="creatingToken" class="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ creatingToken ? 'Creating...' : 'Create token' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- ═══════════════════════════════════════════ -->
<!-- DELETE CONFIRMATION MODAL                  -->
<!-- ═══════════════════════════════════════════ -->
<div *ngIf="showDeleteConfirm" class="fixed inset-0 z-50 overflow-y-auto" aria-modal="true">
  <div class="flex min-h-full items-center justify-center p-4">
    <div class="modal-overlay fixed inset-0 bg-black/40 backdrop-blur-sm" (click)="closeDeleteConfirm()"></div>
    
    <div class="modal-panel relative w-full max-w-sm rounded-2xl shadow-2xl shadow-black/10 ring-1 p-6"
      [ngClass]="isDarkMode() ? 'bg-gray-800 ring-white/10' : 'bg-white ring-black/5'"
      (click)="$event.stopPropagation()">
      
      <!-- Icon -->
      <div class="w-12 h-12 rounded-xl border flex items-center justify-center mb-4" [ngClass]="isDarkMode() ? 'bg-red-950/30 border-red-900/40' : 'bg-red-50 border-red-100'">
        <svg class="w-6 h-6" [ngClass]="isDarkMode() ? 'text-red-400' : 'text-red-500'" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
      </div>

      <h3 class="text-base font-bold mb-1" [ngClass]="isDarkMode() ? 'text-gray-100' : 'text-gray-900'">Revoke this token?</h3>
      <p class="text-sm leading-relaxed mb-6" [ngClass]="isDarkMode() ? 'text-gray-400' : 'text-gray-500'">
        Applications using <strong [ngClass]="isDarkMode() ? 'text-gray-300' : 'text-gray-700'">{{ tokenToDelete?.name }}</strong> will immediately lose API access. This cannot be undone.
      </p>

      <div class="flex items-center justify-end gap-3">
        <button (click)="closeDeleteConfirm()" 
          class="px-4 py-2 text-sm font-medium transition-colors duration-150"
          [ngClass]="isDarkMode() ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-800'">
          Cancel
        </button>
        <button (click)="confirmDelete()" 
          [disabled]="deletingToken"
          class="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-xl shadow-sm hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200">
          <svg *ngIf="deletingToken" class="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ deletingToken ? 'Revoking...' : 'Revoke token' }}
        </button>
      </div>
    </div>
  </div>
</div>
